import InfiniteSlideBar from 'vue-infinite-slide-bar';
import Multiselect from 'vue-multiselect';

import DynamicFormInput from '@/components/Molecules/DynamicFormInput';
import DashboardFormFinal from '@/components/Atoms/DashboardFormFinal';
import { animatedIcons } from '@/components/Atoms/AnimatedIcons';

const components = {
  DynamicFormInput,
  InfiniteSlideBar,
  Multiselect,
  DashboardFormFinal,
  ...animatedIcons
};

export const GlobalComponentsPlugin = {
  install(Vue) {
    Object.entries(components).forEach(([name, component]) => {
      Vue.component(name, component);
    });
  }
};
